// scrollLock.js
// 用法：
// import ScrollLock from './scrollLock.js'
// ScrollLock.lock()   // 锁定滚动
// ScrollLock.unlock() // 解锁滚动

const ScrollLock = (() => {
  let lockCount = 0;

  function preventScroll(e) {
    e.preventDefault();
  }

  return {
    lock() {
      lockCount++;
      if (lockCount > 1) return; // 已经锁定过就不重复执行

      document.addEventListener('wheel', preventScroll, { passive: false });
      document.addEventListener('touchmove', preventScroll, { passive: false });
    },

    unlock() {
      if (lockCount === 0) return;
      lockCount--;
      if (lockCount > 0) return; // 还有其他弹窗没关闭

      document.removeEventListener('wheel', preventScroll);
      document.removeEventListener('touchmove', preventScroll);
    }
  };
})();

export default ScrollLock;
